var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMvMaldives(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_20948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#D21034"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.75 11.25H11.25V33.75H48.75V11.25Z",
    fill: "#007E3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1875 30C23.0454 30 19.6875 26.6421 19.6875 22.5C19.6875 18.3579 23.0454 15 27.1875 15C31.3296 15 34.6875 18.3579 34.6875 22.5C34.6875 26.6421 31.3296 30 27.1875 30Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.375 30C20.2329 30 16.875 26.6421 16.875 22.5C16.875 18.3579 20.2329 15 24.375 15C28.5171 15 31.875 18.3579 31.875 22.5C31.875 26.6421 28.5171 30 24.375 30Z",
    fill: "#007E3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_20948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvMaldives);
export default __webpack_public_path__ + "static/media/mv Maldives.e5ed5d3e824f929b0e4d1eb6c51caa70.svg";
export { ForwardRef as ReactComponent };